<script setup lang="ts" generic="T extends SubmitData">

import type { HandlungBausteinProps, SubmitData } from '@/api/handlungen/types';
import AppButton from '@/application/components/ui/AppButton.vue';
import ConfirmModal from '@/application/components/ConfirmModal.vue';
import { computed, ref } from 'vue';
import { storeToRefs } from "pinia";
import { useBaseDataStore } from "@/user/store/baseDataStore.ts";

const props = defineProps<HandlungBausteinProps<T>>();
const emit = defineEmits(['submit'])

const showConfirm = ref(false);
const clickedButton = ref<{ id: string, label: string } | null>(null);

const { isBroker } = storeToRefs(useBaseDataStore());
const { duzen } = useBaseDataStore();

const sortedButtons = computed(() => {
  return [...props.baustein.data.buttons].sort((a, b) =>
    (a.variant === 'primary' ? 1 : -1) - (b.variant === 'primary' ? 1 : -1)
  );
});

function showModal(id: string, label: string) {
  clickedButton.value = { id, label };
  showConfirm.value = true;
}

function handleSubmit() {
  if (clickedButton.value !== null) emit('submit', clickedButton.value.id);
}
</script>

<template>
  <div class="flex flex-row flex-wrap gap-4 justify-end mt-4">
    <AppButton
      v-for="({ id, label, variant }) in sortedButtons"
      :key="id"
      type="primary"
      :text="variant === 'secondary'"
      :bg="variant === 'secondary'"
      :disabled="isBroker"
      @click="showModal(id, label)"
    >
      {{ label }}
    </AppButton>
    <ConfirmModal
      v-model:show="showConfirm"
      title="Auswahl bestätigen"
      confirm-label="Ok"
      :confirm="handleSubmit"
    >
      {{ duzen('Bist du sicher, dass du', 'Sind Sie sicher, dass Sie') }} <span class="text-gray-900 font-semibold">{{ clickedButton?.label }}</span> {{ duzen('möchtest', 'möchten') }}?
    </ConfirmModal>
  </div>
</template>
